export var BlendMode;
(function (BlendMode) {
    BlendMode["Normal"] = "normal";
    BlendMode["Multiply"] = "multiply";
    BlendMode["Screen"] = "screen";
    BlendMode["Overlay"] = "overlay";
    BlendMode["Darken"] = "darken";
    BlendMode["Lighten"] = "lighten";
    BlendMode["ColorDodge"] = "color-dodge";
    BlendMode["ColorBurn"] = "color-burn";
    BlendMode["HardLight"] = "hard-light";
    BlendMode["SoftLight"] = "soft-light";
    BlendMode["Difference"] = "difference";
    BlendMode["Exclusion"] = "exclusion";
    BlendMode["Hue"] = "hue";
    BlendMode["Saturation"] = "saturation";
    // eslint-disable-next-line no-shadow
    BlendMode["Color"] = "color";
    BlendMode["Luminosity"] = "luminosity";
})(BlendMode || (BlendMode = {}));
export var FillRule;
(function (FillRule) {
    FillRule["Nonzero"] = "nonzero";
    FillRule["Evenodd"] = "evenodd";
})(FillRule || (FillRule = {}));
